<script>
import options from './PageOverlay.options'
export default options
</script>

<template>
  <div
    role="dialog"
    aria-modal="true"
    class="kb-page-overlay__container"
    :class="overlayState"
    @keydown.esc="closeOverlay"
  >
    <div class="kb-page-overlay__cover" v-on:click="closeOverlay"></div>
    <div class="kb-page-overlay__content">
      <button
        class="kb-page-overlay__close-slider-grip"
        draggable="true"
        aria-label="luk-artikel"
      ></button>
      <template v-if="displayOverlayContent">
        <button
          class="kb-page-overlay__close"
          aria-label="Luk artikel"
          @keydown.tab="tabTrap"
          data-order="close"
          v-on:click="closeOverlay"
        >
          <div class="kb-ui-icon kb-ui-icon--ui-close"></div>
        </button>

        <component ref="overlayContentRef" :is="overlayContent" @setTabTargets="setTabTargets" />
      </template>
    </div>
  </div>
</template>
